export default __webpack_public_path__ + "static/media/s1.a1364427.jpg";